import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { for: "protectedPot" }
const _hoisted_4 = ["max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_section = _resolveComponent("sub-section")!

  return (_openBlock(), _createBlock(_component_sub_section, {
    title: "Want to leave some money to pass on if possible?",
    helpTitle: "Protected pot",
    helpText: _ctx.HelpText.protectedPot()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, "Protected pot: " + _toDisplayString(_ctx.protectedPotText), 1),
          _withDirectives(_createElementVNode("input", {
            ref: "protectedPotSlider",
            type: "range",
            class: "form-range",
            id: "protectedPot",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.protectedPotModel) = $event)),
            min: "0",
            max: _ctx.maxProtectedPot,
            step: "1000",
            onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onProtectedPotKeyPress($event))),
            onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onProtectedPotChange && _ctx.onProtectedPotChange(...args))),
            onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onProtectedPotChange && _ctx.onProtectedPotChange(...args))),
            onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onProtectedPotChange && _ctx.onProtectedPotChange(...args)))
          }, null, 40, _hoisted_4), [
            [_vModelText, _ctx.protectedPotModel]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["helpText"]))
}